// 退车核算-计算说明
export const returnAccountingTips = '应收租金=车辆完成交接时间所在款项周期之前周期的应收单金额+（车辆完成交接时间-车辆完成交接时间所在款项周期的第一天）/（自定义设置-车辆完成交接时间所在款项周期的总天数或30天）*车辆完成交接时间所在款项周期的应收金额'
// 支付款项-计算说明
export const paymentTips = `
  <span>
  一、需补欠款的计算 <br/>
    a）需补欠款=支付款项+租金欠款-应退押金 <br/>
    b）先用应退押金抵扣需补欠款，应退押金抵扣完用应退租金抵扣需补欠款，生成应收款单<br/>
  二、应退租金的计算 <br/>
    a）应退租金=已收租金-应收租金-需补欠款 <br/>
  三、应退押金的计算 <br/>
    a）应退押金=已收押金-应收租金-支付项 <br/>
  </span>
  
`
